// extracted by mini-css-extract-plugin
module.exports = {"original":"original--oPSrl","minimal":"minimal--fgyAY"};